import type { NewCommitmentCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useScenarioContext } from '../../context/scenarioContext'
import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeLazyForm } from '../forms/LifeLazyForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

const validateKey = typeUtils.createValidator<NewCommitmentCommandData>()

export const NewCommitmentCommandDataForm = ({
  commandData,
  shouldSkipFrame,
  ...props
}: CommandDataFormProps<NewCommitmentCommandData>) => {
  const translate = useTranslate()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()
  const { scenarioIdForRequestHeader } = useScenarioContext()
  const fetchFrame = useHook(
    'lazyFetchers.life.useLazyFetchNewCommitmentFrame',
  )({
    tenantId,
    ownerId,
    scenarioIdForRequestHeader,
  })

  return (
    <LifeLazyForm
      fetchFrame={fetchFrame}
      mapInitialValues={(frame): NewCommitmentCommandData => ({
        _type: 'NewCommitmentCommandData',
        ...initialFormEntriesFromVBase(frame),
      })}
      {...props}
    >
      <LifeInput
        fallbackInputType="string"
        name={validateKey('commitmentTemplateId')}
        label={translate('createCommitmentModalButton.template')}
      />
    </LifeLazyForm>
  )
}
